import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import "./App.css";


import Home from "./pages/Home";
import Header from "./components/Header";
import Footer from "./components/Footer";
import AboutUs from "./pages/AboutUs";
import Services from "./pages/Services";
import ContactUs from "./pages/ContactUS";
import ShareholdersMeetings from "./pages/ShareholdersMeetings";
import GoTop from "./components/GoTop";
import ScrollToTop from "./components/ScrollToTop";
import DirectorDealings from "./pages/DirectorDealings";
import FinancialReports from "./pages/FinancialReports";
import FinancialCalendar from "./pages/FinancialCalendar";
import AnalystReport from "./pages/AnalystReports";
import NotFound from "./pages/NotFound";
import CorporateActions from "./pages/CorporateActions";

export default function App() {
  return (
    <div className="App">
      <ScrollToTop />
      <Header />

      <div className="wrapper-main">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/director-dealings" element={<DirectorDealings />} />
          <Route path="/financial-reports" element={<FinancialReports />} />
          <Route path="/financial-calendar" element={<FinancialCalendar />} />
          <Route path="/corporate-actions" element={<CorporateActions />} />

          <Route
            path="/shareholders-meetings"
            element={<ShareholdersMeetings />}
          />
          <Route path="/analyst-reports" element={<AnalystReport />} />

          {/* Retired pages: their documents now live in About and Corporate Actions. */}
          <Route path="/presentations" element={<Navigate to="/about-us#download-list" replace />} />
          <Route path="/model-231" element={<Navigate to="/about-us#download-list" replace />} />
          <Route path="/inclusion-document" element={<Navigate to="/about-us#download-list" replace />} />
          <Route path="/adhoc-releases" element={<Navigate to="/corporate-actions" replace />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>

      <GoTop />
      <Footer />
    </div>
  );
}
